import { FormikHelpers } from "formik";
import { useContext } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { isTypeOfPhoneLineSearchForm } from "src/components/Common/UI/SydFilter/SydFilterTypeChecker";
import PhoneLineSearchForm from "./PhoneLineSearchForm";

const emptyPhoneLineSearchForm: IPhoneLineSearchForm = {
  providerID: "",
  sapCode: "",
  phoneNumber: "",
  pendingStatusID: "",
  deleted: "",
  unitID: "",
  unitType: "",
  removalDateFrom: "",
  removalDateTo: "",
  comments: "",
  descline: ""
}

const SearchPhoneLines = () => {
  const sydFilterCtx = useContext(SydFilterContext);

  const activeFilters = sydFilterCtx.activeFilters;
  const clearForm = sydFilterCtx.clearAllFilters;
  const saveFilters  = sydFilterCtx.saveFilters;
  const handleClose = sydFilterCtx.toggleFilterVisibility;

  const initialValues = isTypeOfPhoneLineSearchForm(activeFilters) ? activeFilters as IPhoneLineSearchForm : emptyPhoneLineSearchForm;

  const handleSubmit = async (values: IPhoneLineSearchForm, { setSubmitting }: FormikHelpers<IPhoneLineSearchForm>): Promise<void> => {
    saveFilters(values);
    setSubmitting(false);
    handleClose();
  }

  return (
    <PhoneLineSearchForm initialValues={initialValues} onSubmit={handleSubmit} onClearForm={clearForm} />
  )
}

export default SearchPhoneLines;